import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router doesn't reset scroll position on navigation (unlike a
// traditional multi-page site), so following a link from partway down a
// page — e.g. a footer link — lands you at the same scroll offset on the
// next page instead of its top. Renders nothing; just watches the route.
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
